import React from "react";
import classNames from "classnames";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { planzone } from "@planzone/dto";
import { useRetrieveExportBiRun } from "@planzone/view-models";

import { CreationDate } from "../date";
import { Props } from "./types";
import styles from "./styles.scss";

function ExportBiFinished({ notification, close }: Props) {
  const { t } = useTranslation();
  const push = useNavigate();
  const { retrieveExportBiRun } = useRetrieveExportBiRun();

  return (
    <div className={styles.notification}>
      <div className={styles.header}>
        <p className={styles.title}>
          {t("notifications.exportBiFinished.title")}
        </p>
        <CreationDate date={notification.createdDate} />
      </div>
      <div className={styles.main}>
        <p className={styles.text}>
          {t("notifications.exportBiFinished.status")}{" "}
          <span
            className={classNames(styles.status, {
              [styles.completed]: notification.data.status === "COMPLETED",
              [styles.partial]: notification.data.status === "PARTIAL",
              [styles.failed]: notification.data.status === "FAILED",
            })}
          >
            {t(
              `exportReportsPage.biExportReport.status.${notification.data.status}`,
            )}
          </span>{" "}
          <span
            className={styles.link}
            onClick={() => {
              retrieveExportBiRun({
                planzone: { ...planzone, uuid: notification.data.planzoneId },
                runId: notification.data.runId,
              });
              push("/exports");
              close && close();
            }}
          >
            {t("notifications.exportBiFinished.seeExport")}
          </span>
        </p>
      </div>
    </div>
  );
}

export { ExportBiFinished };
